export {NavigationComponent} from '@shared/layout/navigation/navigation.component';
export {BigBreadcrumbsComponent} from '@shared/layout/navigation/big-breadcrumbs.component';
export {MinifyMenuComponent} from '@shared/layout/navigation/minify-menu.component';
export {SmartMenuDirective} from '@shared/layout/navigation/smart-menu.directive';

export {NavigationModule} from '@shared/layout/navigation/navigation.module'



// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/index.ts